import { __decorate } from "tslib";
import '../../../atom/paragraph/element';
import '../../../atom/list/element';
import { css, html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
export class FormMsg extends LitElement {
    render() {
        return html `
            <ep-p class="error-msg"></ep-p>
            <ep-p class="info">
                <slot></slot>
            </ep-p>
        `;
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (this.infoText) {
            this.infoP.style.setProperty('display', 'block');
            this._slot.innerHTML = this.infoText;
        }
    }
}
FormMsg.styles = css `
        :host(:focus-visible),
        ep-p:focus-visible {
            outline: 0;
            display: block;
        }

        ep-p {
            display: block;
            --ep-text-font-size: var(--ep-form-msg-text-font-size, 12px);
            margin: var(--ep-form-msg-margin, 5px 0 0 10px);
            padding: var(--ep-form-msg-padding, 0);
            --ep-list-padding-inline-start: 15px;
            --ep-list-ul-padding-inline-start: 0;
        }

        .error-msg {
            display: none;
            --ep-text-color: var(--ep-color-danger);
            white-space: var(--ep-form-msg-white-space, normal);
        }

        .info {
            display: none;
        }

        ::slotted(*) {
            display: none;
        }
    `;
__decorate([
    property()
], FormMsg.prototype, "infoText", void 0);
__decorate([
    query('.info')
], FormMsg.prototype, "infoP", void 0);
__decorate([
    query('.error-msg')
], FormMsg.prototype, "errorP", void 0);
__decorate([
    query('slot')
], FormMsg.prototype, "_slot", void 0);
if (!customElements.get('ep-form-msg')) {
    customElements.define('ep-form-msg', FormMsg);
}
//# sourceMappingURL=element.js.map